import { render, staticRenderFns } from "./integralOrderList.vue?vue&type=template&id=a9a4d5f6&scoped=true&"
import script from "./integralOrderList.vue?vue&type=script&lang=js&"
export * from "./integralOrderList.vue?vue&type=script&lang=js&"
import style0 from "./integralOrderList.vue?vue&type=style&index=0&id=a9a4d5f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a4d5f6",
  null
  
)

export default component.exports